import { PlanDetails, TGCTAs } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";
import { ProgramSubTypes, ProgramTypes } from "@swiggy-private/super-ui";

export const isSwiggyOnePlanVariants = (planDetails: PlanDetails) => {
    if (
        planDetails?.program === ProgramTypes.ONE &&
        (planDetails?.type === ProgramSubTypes.PLUS || planDetails?.type === ProgramSubTypes.LITE)
    ) {
        return true;
    }
    return false;
};

export const isSwiggyBlackPlanVariants = (planDetails: PlanDetails) => {
    if (planDetails?.program === ProgramTypes.ONE && planDetails?.type === ProgramSubTypes.BLACK) {
        return true;
    }
    return false;
};

export const isSwiggyOneLitePlan = (planType: string) => {
    return planType === ProgramSubTypes.LITE;
};

export const areValidCtas = (ctas?: TGCTAs[]) => {
    return !isEmpty(ctas?.[0]?.text) && !isEmpty(ctas?.[1]?.text);
};
